<mat-dialog-content>
  <div class="return-dialog-message">{{ data.message }}</div>
  <mat-form-field class="return-dialog-field">
    <input
      matInput
      placeholder="CREDIT"
      (blur)="formatCurrency('credit')"
      [(ngModel)]="credit"
    />
    <span matPrefix>$&nbsp;</span>
  </mat-form-field>
  <ng-container *ngIf="!creditOnly">
    <mat-form-field class="return-dialog-field">
      <input
        matInput
        placeholder="RESTOCKING FEE"
        (blur)="formatCurrency('restockingFee')"
        [(ngModel)]="restockingFee"
      />
      <span matPrefix>$&nbsp;</span>
    </mat-form-field>
    <div class="return-dialog-net">
      NET CREDIT: ${{ netCreditDisplay }}
    </div>
    <mat-checkbox [(ngModel)]="returnToInventory" class="return-dialog-checkbox">
      Frame passes visual inspection / return to inventory
    </mat-checkbox>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="return()">RETURN</button>
  <button mat-raised-button (click)="cancel()">CANCEL</button>
</mat-dialog-actions>
